export const engagementCanvasDataWorkflowId = "/engagement/canvas_data(/:workflow_id)";
